<mat-toolbar class="mobileheader">
    <mat-toolbar-row  fxLayout="column" [style.margin]="mobileHeaderLogoGap"
        [style.height]="mobileHeaderHeight">

        <!-- logo Start -->
        <div  fxLayout="row" fxLayoutAlign="space-between center" class="borderbottom padding-10" fxFlex="100">
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="100">

                <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" class="responsive-toggle" [style.color]="data.headerIconColour">
                    <!-- <img src="assets/icons/download (7).png" alt="marker"
                         style="width: 34px; height: 34px; margin-right: 8px;" />
                    <p style="margin: 0; color: gray; font-size: 12px; word-break: break-word; overflow-wrap: break-word;  white-space: normal;">
                      {{ location_address }}
                    </p> -->
                     <img src="assets/icons/Map Pin.png" alt="marker"
                                style="width: 17px; height: 17px; margin-right: 8px;" /> 
                      <h2 style="font-size: 15px;font-weight: bold;color: rgb(84, 84, 84);margin-right: 6px;">{{data.city}}</h2> 
                      <span style=" font-size: 12px; color: rgb(84, 84, 84);white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: inline-block;max-width: 50%;">{{data.streetAddress}}</span>  

                </div>
                  
                  
            </div>
           
        </div>

        <section fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" style="width: 100%;" class="padding-10">

            <div fxFlex >
                <div *ngIf="layout==0&&mobileLogoEnable==0" fxLayoutAlign="start center">
                    <calsoft-logo [sitename]="data.siteName" *ngIf="!displaySearchBar" [type]="'light'"></calsoft-logo>
                </div>

                <div *ngIf="layout==0&&mobileLogoEnable==1" fxLayoutAlign="start center">
                    <img *ngIf="!displaySearchBar" [src]="serverPath3+mobileLogoSrc" style="width: 100%;"
                        onerror="this.src='';" />
                </div>
            </div>


            <div fxFlex="10" *ngIf="data.disableSearchInHeader==0">
                <div *ngIf="url != '/cart'">
                    <mat-icon style=" cursor: pointer;" [style.color]="data.headerIconColour"
                        fxLayoutAlign="start center" *ngIf="!displaySearchBar"
                        (click)="showSearchBar()">search</mat-icon>
                </div>


                <div *ngIf="displaySearchBar" class="search-bar" fxLayout="row" fxLayoutAlign="end center" fxFlex="350px"
                    fxFlex.gt-sm="350px" fxLayoutGap="5px" style="margin-right: 15px;margin-top: 10px;min-width: 350px;
                    margin-left: -300px;">
                    <calsoft-search (callhideSearchBar)="hideSearch($event)" showSearchBar
                        [searchbarborderRadius]="'15px'"></calsoft-search>
                </div>
            </div>
            <div fxFlex="10" fxLayoutAlign="center center">
                <button [style.color]="data.headerIconColour" class="responsive-toggle" mat-icon-button
                    (click)="toggleSidebar1()">
                    <i style="font-size: 25px;" [style.color]="data.headerIconColour" class="material-icons ">menu</i>
                </button>
            </div>


        </section>


    </mat-toolbar-row>

    

</mat-toolbar>
